import React, { useState, useEffect } from "react";
import { Table, Spin, Pagination } from "antd";
import { DeleteTwoTone, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "./contactStyles.css";
import EditableImage from "../icons/EditIcon";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "../../api/Axios";
import { message, Popconfirm } from "antd";

import { getUpdateStatus } from "./ViewUpdateIndex";
import { remainingViewportHeight } from "../icons/ApplicationColor";
import CommonTopDetails from "./CommonTopDetails";

const UsersTable2 = () => {
  const [data, setData] = useState();

  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 0, 3);
  //console.log(updateAuth);
  //console.log(userInfo);
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/contactslist/${userInfo?.data?.organization?.id}/`,
    search: "",
  });
  const { pageSize, currentPage, url, search } = filterData;

  const handleRowClick = (record) => {
    if (updateAuth) {
      history(
        `/ca-admin/organization/profile/relationships/edit-contact/${record.id}/${userInfo.data.organization.id}`
      );
    }
  };
  const [itemsLength, setItemsLength] = useState();
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        //console.log(res.data.results);
        setItemsLength(res.data.count);
        setData(res.data.results);
        setLoading(false);

        //console.log(data);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const renderAcess = (text, record) => {
    if (record.access) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Contact has been Deleted .",
      duration: 5,
    });

    LoadContacts();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Contact has not been deleted.",
      duration: 5,
    });
  };

  const handleDelete = async (record) => {
    try {
      await Axios.delete(`/contacts/${record.id}/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };

  const columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      fixed: "left",
      width: 140,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      fixed: "left",
      width: 120,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 300,
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      width: 150,
    },
    {
      title: "Position",
      dataIndex: "job_title",
      key: "job_title",
      width: 120,
    },
    // {
    //   title: "Products",
    //   dataIndex: "products",
    //   key: "products",
    //   render: (products) => (
    //     <>
    //       {products.map((product) => {
    //         let color = product.length > 5 ? "geekblue" : "green";
    //         if (product === "Product A") {
    //           color = "volcano";
    //         }
    //         return (
    //           <Tag color={color} key={product}>
    //             {product.toUpperCase()}
    //           </Tag>
    //         );
    //       })}
    //     </>
    //   ),
    // },
    {
      title: "Creation Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (text, record) => {
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" });
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = `${month}-${day < 10 ? "0" + day : day}-${year}`;
        return formattedDate;
      },
    },
    {
      title: "Last Update",
      dataIndex: "updated_at",
      key: "updated_at",
      width: 120,
      render: (text, record) => {
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" });
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = `${month}-${day < 10 ? "0" + day : day}-${year}`;
        return formattedDate;
      },
    },
    ...(false
      ? [
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 70,
            render: renderStatus,
          },
          {
            title: "Access",
            dataIndex: "access",
            key: "access",
            width: 70,
            render: renderAcess,
          },
          {
            title: "Action",
            key: "action",
            fixed: "right",
            width: 100,
            onCell: (record) => {
              return {
                onClick: (event) => {
                  event.stopPropagation(); // this will avoid onRow being called
                  // go to placeUrl(routes.platformDetails, {})
                },
              };
            },
            render: (text, record) => (
              <div
                key={record.id}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <EditableImage
                  key="edit"
                  handleRowClick={handleRowClick}
                  recordId={record}
                  title="edit"
                />
                <Popconfirm
                  title={"Delete Contact"}
                  description=" "
                  onConfirm={() => handleDelete(record)}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                >
                  <DeleteTwoTone
                    key="delete"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </Popconfirm>
              </div>
            ),
          },
        ]
      : []),
  ];

  const history = useNavigate();

  // const LoadApplications = async () => {
  //   console.log(id);
  //   try {
  //     const res = await Axios.get(`/nonorgproducts/${id}/`);
  //     console.log(res.data);
  //     setApplications(res.data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // useEffect(() => {
  //   LoadApplications();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };

  return (
    <div>
      {contextHolder}
      <CommonTopDetails
        title="Admins"
        titleSuffix={`${itemsLength || 0} contact(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false} //updatedauth should be passed when req
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: `/ca-admin/organization/profile/relationships/add-contact/${userInfo.data.organization.id}`,
        }}
        marginPass="15px"
      />

      <Spin spinning={loading}>
        <div className="form-container-2">
          <Table
            size="small"
            rowKey="id"
            dataSource={data}
            columns={columns}
            bordered
            className="table-container"
            pagination={false}
            style={{ margin: "1rem" }}
            scroll={{
              y: `${remainingViewportHeight(30)}px`,
              x: 1000,
            }}
            // onRow={(record) => ({
            //   onClick: (event) => {
            //     handleRowClick(record);
            //   },
            // })}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
    </div>
  );
};

export default UsersTable2;
